export const faqData = [
    {
      section: 'General',
      questions: [
        {
          question: 'What is The Hazer Global?',
          answer: 'The Hazer Global is an online platform providing handyman services, construction goods marketplace, architecture and estimation services, and career opportunities.'
        },
        {
          question: 'What services do you offer?',
          answer: 'We offer: Handyman services for repair and maintenance, Construction goods marketplace for materials and tools, Architecture and estimation services for construction projects, Career opportunities in marketing, technology, finance, and management.'
        },
        {
          question: 'How does your platform work?',
          answer: 'Simply register, either select or post your task, receive quotes from verified available professionals and select the best fit.'
        },
        {
          question: 'Is The Hazer Global a legally registered entity?',
          answer: 'Yes, The Hazer Global is a SECP registered Pvt. Ltd. Company under Pakistan Companies Act having its proper legal standing.'
        },
        {
          question: 'Does the handymen services and job opportunities is the same thing?',
          answer: 'No, it’s different. We directly hire employees on salary or working commission.'
        }
      ]
    },
    {
      section: 'Handyman Services',
      questions: [
        {
          question: 'What types of handyman services do you offer?',
          answer: 'We offer various services, including carpentry, electrical, plumbing, HVAC, and more.'
        },
        {
          question: 'How do you ensure quality work?',
          answer: 'We conduct background checks, verify professional certifications, and review customer feedback.'
        },
        {
          question: 'How can I register myself as a handyman?',
          answer: 'Simply click on the register button at the upper left corner (or click here) of the page, select your field, fill out the form and submit it. Then wait for the verification and approval of your request.'
        },
        {
          question: 'How do you estimate the cost of any task?',
          answer: 'We use different algorithms to determine the actual cost of any task and then we provide opportunity to both parties to bid and agree for the task.'
        }
      ]
    },
    // Additional sections can follow the same structure
  ];